// extracted by mini-css-extract-plugin
export default {"erro":"PaginaErro_erro__G+-K6"};